exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".group-picker{max-height:240px;overflow-y:auto;border:1px solid #ced4da;border-radius:4px;padding:4px}.group-picker-item{display:flex;align-items:center;gap:8px;padding:4px 8px;border-radius:3px}.group-picker-item:hover{background-color:#f0f4ff}.group-picker-item.selected{background-color:#e8f0fe}.group-picker-label{display:flex;align-items:center;gap:8px;margin:0;font-weight:400;cursor:pointer;user-select:none;flex:1;min-width:0}.group-picker-label input[type=checkbox]{margin:0;cursor:pointer;flex-shrink:0}.group-picker-role{width:120px;flex-shrink:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-399ca2ee","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/Users.vue
// module id = 837
// module chunks = 0